import { useQuery } from "@tanstack/react-query";
import type {
  WelcomeAPIInterface,
  WelcomeFetchInterface
} from "@dealer-center/ddc-pages-welcome-interface";

const queryKeyBase = "ddc-pages-welcome";

export function useWelcomeAPIInterface({
  accountId,
  asUserId
}: WelcomeFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { accountId, asUserId }],
    queryFn: () => getFunction(accountId?.trim() || "", asUserId?.trim() || ""),
    enabled: !!accountId && accountId.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunction = async (
  accountId: string,
  asUserId?: string
): Promise<WelcomeAPIInterface> => {
  const asUser = asUserId ? `?asUserId=${asUserId}` : "";
  const res = await fetch("/landing/nxlambda/welcome/" + accountId + asUser);
  if (res.ok) {
    return res.json();
  } else {
    let errorMessage = res.statusText;
    try {
      const body = await res.json();
      if (body?.message) {
        errorMessage = body.message;
      }
    } catch (parseError) {
      console.warn("Failed to parse error response body:", parseError); // eslint-disable-line no-console
    }
    throw new Error(errorMessage);
  }
};
